module.exports = __webpack_public_path__ + "img/building.1869a30e.svg";